import {
  CalendarTodayOutlined,
  DescriptionOutlined,
  TimerOutlined,
} from '@mui/icons-material';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import dayjs from 'dayjs';
import * as React from 'react';
import { Link } from 'react-router-dom';

function PreviousVisitsTab(props) {
  const { appointments } = props;

  const Item = ({ date, time, notes }) => {
    return (
      <ListItem alignItems="center" sx={{ backgroundColor: '#ffffff', mt: 1 }}>
        <Grid container justifyContent="space-around">
          <Grid item xs={12} md={4} lg={2} display="flex" alignItems="center">
            <ListItemIcon sx={{ justifyContent: 'center' }}>
              <CalendarTodayOutlined sx={{ color: '#279BFF' }} />
            </ListItemIcon>
            <ListItemText dir="ltr">
              {dayjs(date).format('DD/MM/YYYY')}
            </ListItemText>
          </Grid>
          <Grid item xs={12} md={4} lg={2} display="flex" alignItems="center">
            <ListItemIcon sx={{ justifyContent: 'center' }}>
              <TimerOutlined sx={{ color: '#279BFF' }} />
            </ListItemIcon>
            <ListItemText dir="ltr">{time}</ListItemText>
          </Grid>
          <Grid item xs={12} md={4} lg={8} display="flex" alignItems="center">
            <ListItemIcon sx={{ justifyContent: 'center' }}>
              <DescriptionOutlined sx={{ color: '#279BFF' }} />
            </ListItemIcon>
            <ListItemText>
              <div
                style={{
                  width: '12rem',
                  height: '1.4rem',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  color: '#279BFF',
                  fontWeight: 'bold',
                  fontSize: 16,
                }}
              >
                <span style={{ color: '#343434', fontWeight: '400' }}>
                  {notes}
                </span>
              </div>
            </ListItemText>
          </Grid>
        </Grid>
      </ListItem>
    );
  };

  return (
    <Grid item xs={12}>
      <List>
        {appointments.map((appointment) => {
          const {
            appointment_date,
            appointment_patient_comments,
            appoinment_time_of_day,
            appointment_calendar_id,
          } = appointment;
          return (
            <Link
              key={appointment_calendar_id}
              to={`/appointment/${appointment_calendar_id}`}
              style={{ color: 'inherit', textDecoration: 'none' }}
            >
              <Item
                date={appointment_date}
                notes={appointment_patient_comments}
                time={dayjs(appoinment_time_of_day, 'HH:mm:ss').format(
                  'HH:mm a'
                )}
              />
            </Link>
          );
        })}
      </List>
    </Grid>
  );
}

export default PreviousVisitsTab;
